import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { Helmet } from 'react-helmet'
import { Box, Container, Grid } from '@material-ui/core'
import UserProfile from '../account/UserProfile'
import AdminProfileDetails from './AdminProfileDetail'
import Loader from '../utils/Loader'

const AdminProfile = props => {
   const navigate = useNavigate()

   const [loading, setLoading] = useState(true)
   const customerId = window.location.pathname.split('/')[4]

   useEffect(() => {
      let mounted = true

      setTimeout(() => {
         if (!localStorage.auth_token) navigate('/login')
         mounted && setLoading(false)
      }, 1000)

      return () => (mounted = false)
   }, [navigate])

   return (
      <>
         <Helmet>
            <title>{loading ? 'Loading...' : 'Profile | The HosePod'}</title>
         </Helmet>
         <Box
            sx={{
               backgroundColor: 'background.default',
               minHeight: '100%',
               py: 3
            }}
         >
            <Container maxWidth='lg'>
               {loading ? (
                  <Loader />
               ) : (
                  <Grid container spacing={3}>
                     <Grid item lg={4} md={6} xs={12}>
                           <UserProfile customerid={customerId} />
                     </Grid>
                     <Grid item lg={8} md={6} xs={12}>
                        <AdminProfileDetails customerid={customerId} />
                     </Grid>
                  </Grid>
               )}
            </Container>
         </Box>
      </>
   )
}

export default AdminProfile
